import React from "react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from "../ui/alert-dialog";

/** Replaces `window.confirm("Cancel this request?")` on My Availability. */
export const CancelAvailabilityDialog = ({ open, onOpenChange, request, onConfirm }) => {
  if (!request) return null;
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="cancel-availability-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Cancel this request?</AlertDialogTitle>
          <AlertDialogDescription>
            {request.request_type === "TIME_OFF" ? "Day off request" : "Availability submission"} for {request.target_month}
            {request.date ? ` (${request.date})` : ""} - current status <strong>{request.status}</strong>. Cancelling removes it from your manager's review queue; it will no longer be considered when building the schedule.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="cancel-availability-back">Back</AlertDialogCancel>
          <AlertDialogAction data-testid="cancel-availability-confirm" onClick={onConfirm}>Cancel Request</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
